import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, Util, Logo } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';
import { SearchBar } from '@grandvisionhq/search';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import LocaleSelectOverlay from '../LocaleOverlay/LocaleSelectOverlay.js';
import { HeaderMenu } from './HeaderMenu/HeaderMenu.js';

const Header = ({ renderCartButton , renderWishlistMenuItem , availableLocales , algoliaHeaderConfig , menuItems , myAccountButton , logo , logoMobile , logoLink , pageRoutes , onSubmit , preview , countrySwitcherOptions , children , renderSiteNav =true , hasOnlyLogo =false , siteName , className , ordersUrl ,  })=>{
    const [searchHasFocus, setSearchHasFocus] = React.useState(false);
    const { getLabel  } = useIntl();
    const { isMultilingualEnabled  } = useFeatureToggles();
    const openSiteNavEvent = React.useRef();
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
    const { isHidden , isCondensedHeader , headerRef  } = Util.useHeaderOnScroll(isMobile);
    /** Register sitenav.open event, needs window */ React.useEffect(()=>{
        openSiteNavEvent.current = Util.createCustomEvent('sitenav.open');
    }, []);
    const headerClasses = classnames('header__header', {
        'header__header--hidden': isHidden && isMobile,
        'header__header--search-has-focus': searchHasFocus
    });
    const showMultilingualComponents = !hasOnlyLogo && isMultilingualEnabled && !preview && !!availableLocales && availableLocales.length > 1;
    const logoLinkPath = logoLink ? logoLink : (pageRoutes === null || pageRoutes === void 0 ? void 0 : pageRoutes.root) || '/';
    const logoTitle = siteName ? `${siteName} home` : 'Home';
    const handleFocus = React.useCallback(()=>{
        setSearchHasFocus(true);
    }, []);
    const handleClose = React.useCallback(()=>{
        setSearchHasFocus(false);
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('header', className, {
            'is-header-condensed': isCondensedHeader
        })
    }, /*#__PURE__*/ React.createElement("header", {
        className: headerClasses,
        role: "banner",
        ref: headerRef
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames('site-container header__container', {
            'header__container--center': hasOnlyLogo
        })
    }, !hasOnlyLogo && renderSiteNav && /*#__PURE__*/ React.createElement("button", {
        className: "header__hamburger",
        onClick: toggleSiteNav,
        type: "button",
        "aria-label": getLabel('common.menu.open')
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "hamburger"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "header__logo-wrapper"
    }, /*#__PURE__*/ React.createElement(Logo, {
        className: isMobile ? 'header__logo--mobile' : 'header__logo',
        url: logoLinkPath,
        image: isMobile ? logoMobile : logo,
        title: logoTitle,
        srOnlyText: siteName
    })), !hasOnlyLogo && /*#__PURE__*/ React.createElement(React.Fragment, null, isMobile && renderSearchBar(), /*#__PURE__*/ React.createElement(HeaderMenu, {
        renderCartButton: renderCartButton,
        renderWishlistMenuItem: renderWishlistMenuItem,
        showMultilingualComponents: showMultilingualComponents,
        availableLocales: availableLocales,
        myAccountButton: myAccountButton,
        menuItems: menuItems,
        toggleMobileSearch: handleFocus,
        countrySwitcherOptions: countrySwitcherOptions,
        ordersUrl: ordersUrl
    }), !isMobile && renderSearchBar()))), showMultilingualComponents && /*#__PURE__*/ React.createElement(LocaleSelectOverlay, {
        logo: logoMobile ? logoMobile : logo,
        availableLocales: availableLocales !== null && availableLocales !== void 0 ? availableLocales : []
    }), children);
    /**
   * event dispatched for opening the sitenavigation on mobile
   */ function toggleSiteNav() {
        openSiteNavEvent.current && window.dispatchEvent(openSiteNavEvent.current);
    }
    /**
   * Render SearchBar component
   */ function renderSearchBar() {
        if (!algoliaHeaderConfig) {
            return null;
        }
        const { apiKey , appId  } = algoliaHeaderConfig;
        if (!apiKey || !appId || !onSubmit) {
            return null;
        }
        const searchClassName = classnames('header__search', {
            'header__search--mobile': isMobile,
            'header__search--desktop': !isMobile,
            'header__search--focus': searchHasFocus,
            'header__search--condensed': isCondensedHeader
        });
        return /*#__PURE__*/ React.createElement("div", {
            className: searchClassName,
            role: "search"
        }, /*#__PURE__*/ React.createElement(SearchBar, {
            pageRoutes: pageRoutes,
            onSubmit: onSubmit,
            config: algoliaHeaderConfig,
            onFocus: handleFocus,
            onClose: handleClose,
            forceFocus: searchHasFocus,
            isMobile: isMobile
        }));
    }
};

export { Header, Header as default };
//# sourceMappingURL=Header.js.map
